module.exports = __webpack_public_path__ + "static/img/goods1.7b50ce0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/goods1.png
// module id = iv0l
// module chunks = 1